import { useLayoutEffect, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { LoadingFallback } from "@/components/layout/LoadingFallback";
import ErrorBoundary from "@/components/ErrorBoundary";

/**
 * Layout for public routes — applies `public-surface` class to <html> so the
 * dark-mode background is replaced with the editorial light surface everywhere.
 */
export default function PublicLayout() {
  useLayoutEffect(() => {
    document.documentElement.classList.add("public-surface");
    return () => document.documentElement.classList.remove("public-surface");
  }, []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
}
